<div class="row card-header px-4 py-3 border-b">
    <div class="text-[15px] font-medium tracking-tight truncate m-0">
        String Healthiness
    </div>
</div>
<div class="p-4 bg-white" *ngIf="data">
    <!-- Header with Overall Health -->
    <div class="flex items-center justify-between mb-4">
        <div class="text-[13px] font-medium text-gray-600">
            Overall Healthy Status
        </div>
        <div class="inline-flex items-center gap-1 px-2 py-0.5 rounded-md border border-gray-200 bg-gray-50">
            <span class="text-[13px] font-bold text-green-600">{{ getOverallHealthyPercentage() }}%</span>
        </div>
    </div>

    <!-- Main Metric -->
    <div class="mb-5 flex flex-col items-center py-2">
        <div class="text-4xl font-bold text-gray-900 leading-none">
            {{ getTotalHealthy() }}
        </div>
        <div class="text-[13px] text-gray-500 mt-1">
            out of {{ data.total }} strings are healthy
        </div>
    </div>

    <!-- Breakdown Grid -->
    <div class="grid grid-cols-2 border-t border-gray-100 pt-2 mt-2">
        <div *ngFor="let item of data.items; let i = index" 
             class="flex flex-col py-3 px-2 border-gray-100"
             [ngClass]="{
                 'border-b': i < 2,
                 'border-r': i % 2 === 0
             }">
            <div class="text-xl font-bold text-gray-900 leading-none mb-1.5">{{ item.count }}</div>
            <div class="text-[12px] font-medium text-gray-500 leading-tight" [title]="item.category">{{ item.category }}</div>
        </div>
    </div>
</div>
